---
title: Why Process Sucks (Except it Doesn't)
date: 2020-10-26T16:50:08-05:00
draft: true
---

- example of good process: standup
    - everybody knows what's expected of them
    - everybody knows what to expect of others
    - everybody knows how to identify when something goes off the rails
        - parking lot items
        - call time
- example of bad process
    - manual checklist for completing a task
    - time sink meetings (get everyone in a room)

- what makes a process bad
    - you end up serving the process, rather than the process serving you
    - you do manually what should be automated

- goals of good process
    - brings clarity
    - prevents negative outcomes
        - forgotten parts of a task/procedure
        - missed deadlines


